import { render, staticRenderFns } from "./InventorySummaryTable.vue?vue&type=template&id=1ab750e9&scoped=true"
import script from "./InventorySummaryTable.vue?vue&type=script&lang=ts"
export * from "./InventorySummaryTable.vue?vue&type=script&lang=ts"
import style0 from "./InventorySummaryTable.vue?vue&type=style&index=0&id=1ab750e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab750e9",
  null
  
)

export default component.exports